export interface VoucherProgramRequest {  

    companyId: string;

     companyName: string;

    // Voucher Vaccines
    
    voucherVaccinesJson: VaccineDto[];

    // Voucher Information
    
    voucherProgramName: string;

    
    fluVoucherExpirationDate: Date;

    
    routineVoucherExpirationDate: Date;

    // Invoice Information        

    businessName: string;
    
    phone: string;    
    
    email: string;

    fax: string;
    
    taxExempt: boolean;
    
    employerIdentificationNumber: string;

    // Billing Address
    
    billingFirstName: string;
    
    billingLastName: string;
    
    billingAddress1: string;

    billingAddress2: string;
    
    billingCity: string;
    
    billingState: string;
    
    billingZip: string;

    // Legal Address
    
    legalFirstName: string;
    
    legalLastName: string;
    
    legalAddress1: string;

    legalAddress2: string;
    
    legalCity: string;
    
    legalState: string;
    
    legalZip: string;

    // Voucher Agreement
    agreementVersion: string;

    agreementText: string;
          
    consentElectronic: string;
    
    signatureName: string;

    signatureJobTitle: string;
    
    signatureDate: Date;  

    // W9 document
    w9DocumentFile: File | null;    

    sameAsBusiness : boolean;
}

export interface VaccineDto
{    
    vaccineId: number;

    vaccineName: string;

    vaccineNameSp: string;

    abbrevatedVaccineName: string;

    abbrevatedVaccineNameSpanish: string;
    
    vaccinePrice: number;
}

export class LanguageVariables {
    // language variables

    public thirdPartyRightsText: string = '';
    public thirdPartyRights: string = '';

    public inWitnessWhereOff: string = '';

    public inWitnessWhereOff2ndLine: string = '';

    public wallGreensCommOffsiteTitle1: string = '';

    public wallGreensCommOffsiteTitle2: string = '';

    public wallGreensResponsibilities: string = '';

    public wallGreensResponsibilitiesPara1Heading: string = '';

    public sendLegalNoticeToClient: string = '';

    public sendLegalNoticeToWalgreens: string = '';

    public wallGreensResponsibilitiesCvrdServices: string = '';

    public profJudgementHeading: string = '';

    public profJudgementText: string = '';

    public provHealthCrProfHdng: string = '';

    public provHealthCrProfText: string = '';

    public clientsResponsibilites: string = '';

    public vouchersHeading: string = '';

    public vouchersText: string = '';

    public offSiteLocation: string = '';

    public eligibleParticipants: string = '';

    public important: string = '';

    public offSiteLocationText1: string = '';

    public eligibleParticipantsText1: string = '';

    public siteMin: string = '';

    public siteAvg: string = '';

    public siteMinText: string = '';

    public siteAvgText: string = '';

    public pmtAndBIlling: string = '';

    public paymentHd: string = '';

    public paymentText: string = '';

    public latePayment: string = '';

    public latePaymentText: string = '';

    public costIncreasetext: string = '';

    public costIncrease: string = '';

    public termAndTermCaps: string = '';

    public termAndTerm: string = '';

    public termAndTermText: string = '';

    public effectAndTerminiation: string = '';

    public effectAndTerminiationText: string = '';

    public waiver: string = '';

    public waiverText: string = '';

    public insurAndIndemnify: string = '';

    public insurance: string = '';

    public insuranceText: string = '';

    public indemnification: string = '';

    public indemnificationText: string = '';

    public generalTerms: string = '';

    public confidentiality: string = '';

    public confidentialityP1: string = '';

    public phi: string = '';

    public phiAb: string = '';

    public confidentialityP2: string = '';
    public confidentialityUniversalText: string = '';
    public singleStarTAndC: string = '';
    public singleStarTAndC2: string = ''
    public article2Text: string = '';

    public Advertising: string = '';

    public AdvertisingText: string = '';

    public frcMaj: string = '';

    public frcMajText: string = '';

    public compliance: string = '';

    public complianceText: string = '';

    public assignment: string = '';

    public assignmentText: string = '';

    public notices: string = '';

    public noticesText: string = '';

    public entireAgr: string = '';

    public entireAgrText: string = '';

    public counterPart: string = '';
    public counterPartsText: string = '';

    public rights: string = '';

    public businessName: string = '';
    public name: string = "";
    public eSignature: string = "";
    public title: string = '';
    public attentionTo: string = '';
    public date: string = '';
    public district: string = '';
    public attentionToTxt: string = '';
    public address1: string = '';
    public address2: string = '';
    public city: string = '';
    public state: string = '';
    public zip: string = '';
    public approveAgrmnt: string = '';
    public approveText: string = '';
    public electrSign: string = '';
    public notes: string = '';
    public pageTitle: string = '';
    public approve: string = '';
    public reject: string = '';
    public submit: string = '';
    public printAgreementTxt: string = '';
    public clinicLocation: string = '';
    public clinicDate: string = '';
    public clinicTime: string = '';
    public contact: string = '';
    public phone: string = '';
    public estShots: string = ''
    public location: string = '';
    public time: string = '';
    public email: string = '';
    public emailAgrmntTo = '';
    public multipleEmailAddrss = '';
    public sendAgreeMnt = '';
    public editAgreeMnt = '';
    public saveAgreeMnt = '';
    public cancelTxt = '';
    public noteTxt = '';
    public table1 = '';
    public cancel: string = '';
    public contactName: string = "";
    public contactPhone: string = "";
    public contactEmail: string = "";
    public dose: string = "";
    public privateClinicFees: string = "";
    public privateClinicFeesText: string = "";
    public businessConfidentiality: string = "";
    public businessConfidentialityText: string = "";
    public clinicFee: string = "";
    public participants = "";
    public changeEventDefinedEN: string = "";
    public changeEventDefinedTextEN: string = "";
}